$(document).ready(function () {

	const cardsSwiper = new Swiper('.cards-slider', {
		spaceBetween: 30,
		grabCursor: true,
		navigation: {
			nextEl: ".swiper-cards-button-next",
			prevEl: ".swiper-cards-button-prev",
		},
		slidesOffsetAfter: 30,
		breakpoints: {
			0: { slidesPerView: 1.1 },
			576: { slidesPerView: 1.2 },
			768: { slidesPerView: 2.2 },
			992: { slidesPerView: 3.2 },
		},
		on: {
			init: function () {
				toggleDisabledClasses(this);
			},
			slideChange: function () {
				toggleDisabledClasses(this);
			},
			resize: function () {
				toggleDisabledClasses(this);
			}
		}
	});

	function toggleDisabledClasses(swiperInstance) {
		const prevBtn = document.querySelector(".swiper-cards-button-prev");
		const nextBtn = document.querySelector(".swiper-cards-button-next");

		if (swiperInstance.isBeginning) prevBtn.classList.add("disabled");
		else prevBtn.classList.remove("disabled");

		if (swiperInstance.isEnd) nextBtn.classList.add("disabled");
		else nextBtn.classList.remove("disabled");
	}

	// List blocks slider
	new Swiper('.list-blocks-slider', {
		loop: true,
		spaceBetween: 20,
		pagination: {
			el: '.list-blocks-slider .swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.list-blocks-slider .swiper-button-next',
			prevEl: '.list-blocks-slider .swiper-button-prev',
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				slidesOffsetBefore: 40,
				slidesOffsetAfter: 40,
			},
			576: {
				slidesPerView: 2,
				slidesOffsetBefore: 80,
				slidesOffsetAfter: 80,
			},
			992: {
				slidesPerView: 4,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				loop: false,
			},
		},
	});

	// Quote slider
	new Swiper('.quote-slider', {
		loop: true,
		slidesPerView: 1,
		navigation: {
			nextEl: '.quote-slider .swiper-button-next',
			prevEl: '.quote-slider .swiper-button-prev',
		},
	});

	// Logo slider
	new Swiper('.list-blocks-slider-6', {
		loop: true,
		spaceBetween: 20,
		pagination: false,
		navigation: false,
		breakpoints: {
			0: { slidesPerView: 4 },
			576: { slidesPerView: 4 },
			992: { slidesPerView: 6 },
		},
	});

	new Swiper('.hero-bg-images', {
		loop: true,
		effect: 'fade',
		speed: 1200,
		allowTouchMove: false,

		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},

		fadeEffect: {
			crossFade: true,
		},

		pagination: {
			el: '.hero-pagination',
			clickable: true,
		},
	});

});
